export const tiposDocumento = [
  {
    id: 1,
    value: 'DNI',
    valueToShow: '1-DNI',
  },
  {
    id: 2,
    value: 'LE',
    valueToShow: '2-LE',
  },
  { id: 3, value: 'LI', valueToShow: '3-LI' },
  { id: 4, value: 'CI PF', valueToShow: '4-CI PF' },
  { id: 5, value: 'Pasaporte', valueToShow: '5-Pasaporte' },
]
